import axios from "axios";
import globals from "@/config/globals";
import _ from 'lodash';

export default {
  index() {
    return axios.get(`${globals.getApiHost()}/carriers?`);
  },
}
